module.exports = __webpack_public_path__ + "static/media/ME.72abed12.png";